export const DownloadIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
    <svg width={size} height={size} viewBox={`0 0 10 13`} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M-1.07942e-05 12.8333H9.33332V11.5H-1.07942e-05V12.8333ZM9.33332 5.5H6.66666V0H2.66666V5.5H-1.07942e-05L4.66666 10.1667L9.33332 5.5Z" fill={color} />
    </svg>

);
